// import assest from '@/json/assest'
import assest from "../../json/assest";
import {
  Box,
  Button,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import React from "react";
import styles from "../../styles/pages/editors.module.scss";
import FilterModal from "../FilterModal/FilterModal";
import TableCalenderIcon from "../../ui/Icons/TableCalenderIcon";
import TableFilterIcon from "../../ui/Icons/TableFilterIcon";
import AlltimemenuTwo from "../../ui/Customdropdown/AlltimemenuTwo";

// interface ModaltableHeaderProps {
//     searchType: boolean,
//     allVideo: boolean,
//     pendingBtn: boolean,
//     filterBtn: boolean,
//     total:any
//     // type:string
// }

const ModaltableHeader = (props) => {
  console.warn(
    "🚀 ~ file: ModaltableHeader.jsx:21 ~ ModaltableHeader ~ props:",
    props
  );
  const [searchValue, setSearchValue] = React.useState("");
  // console.warn(searchValue)
  const [openFilterModal, setOpenFilterModal] = React.useState(false);
  const handleOpenFilterModal = React.useCallback(() => {
    setOpenFilterModal(true);
  }, []);
  const handleCloseFilterModal = React.useCallback(() => {
    setOpenFilterModal(false);
  }, []);
  return (
    <>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        className={styles.innerTableHeader}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          className={styles.calendarData}
        >
          <Typography variant="body1" className={styles.dataTxt}>
            Showing videos for
          </Typography>
          <AlltimemenuTwo />
          <Typography variant="body2" className={styles.datetxt}>
            (April 23, 2023 - Today)
          </Typography>
        </Stack>
        {props?.searchType && (
          <Box className="tableDataSearch">
            <TextField
              label=""
              id="outlined-size-normal"
              placeholder="Enter an email address, submitter name, VSID to search..."
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={searchValue ? styles.startAdmnt : undefined}
                  >
                    <img
                      src={assest.searchicon}
                      width={11}
                      height={11}
                      alt="icon"
                    />
                  </InputAdornment>
                ),
                endAdornment: searchValue?.length ? (
                  <InputAdornment position="end">
                    <Button onClick={() => setSearchValue("")}>Clear</Button>
                  </InputAdornment>
                ) : null,
              }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className={searchValue ? styles.onFocus : undefined}
            />
          </Box>
        )}
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          className={styles.calenderVideo}
        >
          {props?.pendingBtn && (
            <Button className={styles.pendingBtn}>Pending Revision</Button>
          )}
          {props?.filterBtn && (
            <Button
              className={styles.btncalender}
              onClick={handleOpenFilterModal}
            >
              <TableFilterIcon />
            </Button>
          )}

          <Button className={styles.btncalender}>
            <TableCalenderIcon />
          </Button>
          {props?.allVideo && (
            <Typography variant="body1">
              <span>All videos:</span> {props.total}
            </Typography>
          )}
        </Stack>
      </Stack>
      <FilterModal
        open={openFilterModal}
        type={"filter_QC"}
        onClose={handleCloseFilterModal}
      />
    </>
  );
};

export default ModaltableHeader;
